import '@mdi/font/css/materialdesignicons.min.css';
import '~/assets/css/main.css';
import '~/modules/validation';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import VueScreen from 'vue-screen';
import AuthService from '~/services/authService';
import authStorePlugin from './plugins/authStorePlugin';
import i18n from '~/modules/i18n';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import primeVueConfig from '~/components/Tangerine/primevue';
import router from '~/modules/router';
import vueTestidPlugin from './plugins/vue-testid-plugin/vue-testid-plugin';
import { createApp } from 'vue';
import { createPinia, setActivePinia } from 'pinia';
import { eventPlugin } from '~/plugins/eventPlugin';
import { vMaska } from 'maska';
import preMount from '~/utils/preMount';
import { useAppStore } from '~/stores/useAppStore';
import HttpService from '~/services/httpService';

const app = createApp(App);
const pinia = createPinia();
setActivePinia(pinia);
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.use(i18n);
app.provide('$translateFn', i18n.global.t);

app.directive('maska', vMaska);
app.use(VueScreen, 'tailwind');
app.use(PrimeVue, primeVueConfig);
app.use(ToastService);
app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);
app.use(authStorePlugin, { pinia });
app.use(vueTestidPlugin, {
  attribute: 'data-test',
  useLocation: true,
  overwrite: true,
});

app.config.errorHandler = (err, instance, info) => {
  console.error('Global error:', err);
  console.log('Vue Instance:', instance);
  console.log('Error info:', info);
};

const { kcConfig, appConfig, featConfig } = await preMount((config) => config);

HttpService.CallInit(appConfig.baseURL);
AuthService.CallInit(kcConfig, () => {
  // TODO: Check if this 'AppStore' is needed
  useAppStore().setAppConfig(appConfig);
  app.use(router);
  app.use(eventPlugin, pinia);

  app.mount('#app');
});
